module.exports = __webpack_public_path__ + "img/photocasescansmallImei.d4d8ecbc.png";